// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"12":"profiler","9777":"recorder"}[chunkId] + "." + {"12":"74d3a50caf34ded8","9777":"8cdb8633bcf27534"}[chunkId] + ".js";
};